
import { defineComponent, onMounted, ref, watch } from 'vue';
import { avatarService } from '@/services/avatar';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';

export default defineComponent({
    name: 'app-avatar-breadcrumb',
    props: {
        categoryId: {
            default: null
        }
    },
    setup(props) {
        const router = useAppRouter();
        const list = ref([]);

        const fetch = useCrudActions().executeAction({
            canExecute: () => props.categoryId != null && props.categoryId > 0,
            request: () => avatarService.category.breadcrumb(props.categoryId),
            onSuccess: ({ data }) => (list.value = data),
            onError: () => void (list.value = [])
        });

        const routerLinkToAvatarCategory = (parentId: any) =>
            router.push({
                name: ROUTE_NAME_AVATAR.CATEGORY.INDEX,
                query: parentId ? { parentId } : {}
            });

        onMounted(() => fetch());

        watch(() => props.categoryId, fetch);

        return { list, routerLinkToAvatarCategory };
    }
});
